import React from 'react';

const ArticleComponent = ({ articles, onArticleClick }) => {
  const articlePairs = [];
  for (let i = 0; i < articles.length; i += 2) {
    articlePairs.push(articles.slice(i, i + 2));
  }

  const handleArticleClick = (article, event) => {
    const hasExternalLink = article.link && article.link.startsWith('http');

    if (!hasExternalLink) {
      event.preventDefault();
      onArticleClick(article);
    }
  };

  return (
    <div className="content-list-article" style={{ width: '100%' }}>
      {articlePairs.map((pair, pairIndex) => (
        <div key={pairIndex} className="articles-row">
          {pair.map((article) => {
            const hasExternalLink = article.link && article.link.startsWith('http');
            const articleLink = hasExternalLink
              ? article.link
              : `/article/${article.id}/${article.slug}`; // Utiliser le slug

            const linkProps = hasExternalLink
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {};

            return (
              <a
                key={article.id}
                className="one-article"
                href={articleLink}
                {...linkProps}
                onClick={(event) => handleArticleClick(article, event)}
                style={{ cursor: 'pointer' }}
              >
                <div className="left-content">
                  <span className="top-content">{article.date}</span>
                  <div className="between-content">
                    <p className="name-descr">{article.title}</p>
                  </div>
                  <button className="bottom-content">
                    {hasExternalLink ? 'Lire sur le site' : 'Lire l\'article'}
                  </button>
                </div>
                <div className="right-content">
                  <img src={article.image} alt={article.alt} loading="lazy" />
                </div>
              </a>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ArticleComponent;